const PriestProfileTab = {
    general: "general",
    family: "family",
    qualification: "qualification",
    placements: "placements",
    lifePathOnTheMap: "lifePathOnTheMap",
    pathOfLife: "pathOfLife",
    pictures: "pictures",
    files: "files",
    occupations: "occupations",
    references: "references",
    disciplinaryMatters: "disciplinaryMatters",
    notes: "notes"
};

export default PriestProfileTab;
